
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.727.5H3.275a.495.495 0 00-.467.673A19.286 19.286 0 014.02 8a19.286 19.286 0 01-1.213 6.827.495.495 0 00.466.673h9.454a.499.499 0 00.46-.695A17.817 17.817 0 0112.02 8a17.817 17.817 0 011.167-6.805.499.499 0 00-.46-.695z","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    